export default __webpack_public_path__ + "static/media/shop.com.e18a3dbe.png";